﻿/*
* jQuery Plugin: Equal Heights
* Version: 1.0
* Author: James Hull (http://www.jameshull.com.au/)
* Copyright (c) 2012 Roadhouse Digital (http://www.roadhouse.com.au/)
* Usage:
*	Use the following jQuery extension to set equal height for collections
*	of html elements.
*	Methods:
*		Set the height for all elements selected to the highest element in the collection.
*		$(selector).equalizeHeights();
*		
*		Add the subgroup parameter and the plugin will set the element to the highest
*		element in the sub collection multiple. This is ideal for setting consistant
*		heights across rows of elements.
*		$(selector).equalizeHeights(2);
* 
*/

(function ($) {

	$.fn.equalizeHeights = function (subgroup) {

		if (subgroup) {
			var count = $(this).length;
			for (var i = 0; i < Math.ceil(count / subgroup) ; i++) {
				$(this.splice(0, subgroup)).equalizeHeights();
			}
		}
		else {
			return this.height(
			Math.max.apply(this,
				$(this).map(function (i, e) {
					return $(e).height()
				}).get())
			);
		}
	};

})(jQuery);
